/**
 * enum containing the global notification setting and its wrapping section
 * these should match what the `/notification-settings` API returns,
 * as this setting is used to disable the rest of the email settings
 */
export let GlobalEmailNotificationsSetting;

(function (GlobalEmailNotificationsSetting) {
  GlobalEmailNotificationsSetting["Section"] = "global_switch";
  GlobalEmailNotificationsSetting["Setting"] = "is_enabled";
})(GlobalEmailNotificationsSetting || (GlobalEmailNotificationsSetting = {}));